export interface TomaInventario {
  idTomaInventario: number;
  nombre: string;
  fecha: string;
  idDeposito: number;
  idUsuario?: number | null;
  estado: string; // PEN=Pendiente, PRO=En Proceso, COM=Completado, AJU=Ajustado
  fechaFinalizacion?: string | null;
  observaciones?: string;
  depositoNombre?: string;
  detalles?: TomaInventarioDetalle[];
}

export interface TomaInventarioDetalle {
  idTomaInventarioDetalle: number;
  idTomaInventario: number;
  idArticulo: number;
  cantidadSistema: number;
  cantidadFisica?: number | null;
  diferencia?: number | null;
  observaciones?: string;
  articuloCodigo?: string;
  articuloDescripcion?: string;
}

export const initialTomaState: Partial<TomaInventario> = {
  nombre: '',
  idDeposito: 0,
  observaciones: '',
};
